import ConfirmMenu from 'root/components/molecules/ConfirmMenu';
import styled from 'styled-components';

export const StyledConfirmMenu = styled(ConfirmMenu)(
  ({ theme: { spacing } }) => ({
    left: 'auto',
    right: spacing.md,
    top: spacing.xxl,
  }),
);
